import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";


// components
import ClassConfigurationList from "./_list";
import {showLoader} from "../../../components/loader/loader";


// actions
import {
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setUserIsAdmin
} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";


const ClassConfiguration = (props) => {
    const path = 'configuration/classConfiguration';
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
            
        const _user = localStorage.getItem('userData') !== '' ? JSON.parse(localStorage.getItem('userData')) : null

        if(_user != null)
            props.setUserIsAdmin(path, _user?.isAdmin ? true : false)
    },[]);


    return <>
        {loading && showLoader()}
        { componentState && <ClassConfigurationList path={path} /> }
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setUserIsAdmin,
})

export default connect(mapStateToProps, mapActionsToProps)(ClassConfiguration);